module.exports = __webpack_public_path__ + "static/debtBox-ceeb7e47a92f92c456db084325bfbb90.png";